var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityTagsSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.02293005 -0.84962963 10.98147493 -1.45456294 16.08984375 2.2265625 C18.54297381 4.72544678 20.82809241 7.25447347 23 10 C21.20222373 13.80705564 19.3319739 16.33442088 16 19 C12.75 19.875 12.75 19.875 9 19 C4.53454949 15.95181368 0.53432711 12.64601712 -0.5703125 7.17578125 C-0.56330202 4.71860968 -0.40935 2.42072405 0 0 Z M3 3 C4 5 4 5 4 5 Z M19 10 C20 12 20 12 20 12 Z ",
    fill: "#FFFFFF",
    transform: "translate(1,3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityTagsSolid);
export default __webpack_public_path__ + "static/media/clarity_tags-solid.14546c41560b276e644ed9b1f1bcf047.svg";
export { ForwardRef as ReactComponent };